import { render, staticRenderFns } from "./single-video.vue?vue&type=template&id=0da59f51&scoped=true&"
import script from "./single-video.vue?vue&type=script&lang=js&"
export * from "./single-video.vue?vue&type=script&lang=js&"
import style0 from "./single-video.vue?vue&type=style&index=0&id=0da59f51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da59f51",
  null
  
)

export default component.exports